import React from "react";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import EstimateProjectForm from "../../WebDevelopmentPage/EstimateProjectForm";

const highlights = [
  {
    title: "Employee Management",
    description: "Profiles, onboarding, documents, and organization structure in one place.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.5" />
        <path d="M4 20c0-4 3.5-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "Payroll & Attendance",
    description: "Automated salary processing with real-time attendance and shift tracking.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="6" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M3 10h18" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "Leave Management",
    description: "Self-service leave requests with multi-level approval workflows.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 2v4M16 2v4M4 10h16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Recruitment & Performance",
    description: "Hiring pipeline, appraisals, KPIs, and workforce analytics.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3l2.4 4.8 5.3.8-3.8 3.7.9 5.3L12 15.8 7.2 17.6l.9-5.3L4.3 8.6l5.3-.8L12 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      </svg>
    ),
  },
];

const HrmIntroSection: React.FC = () => {
  return (
    <section className="wdev-intro hrm-intro" aria-labelledby="hrm-intro-title">
      <div className="container">
        <div className="wdev-intro__grid">
          <AnimatedSection className="wdev-intro__content">
            <span className="wdev-label wdev-label--purple">Human Resource Management</span>
            <h2 id="hrm-intro-title" className="wdev-intro__title">
              HRM Software Development Company
            </h2>

            <p className="wdev-intro__text">
              Managing human resources manually — spreadsheets for attendance, paper leave forms,
              and disconnected payroll processes — slows down your business and increases errors.
              A complete HRM system brings every HR function into one automated platform.
            </p>
            <p className="wdev-intro__text">
              WebTech develops comprehensive Human Resource Management software for businesses of
              all sizes — from employee onboarding and attendance tracking to payroll processing,
              recruitment, performance reviews, and compliance reporting.
            </p>
            <p className="wdev-intro__text">
              We are a trusted HRM software development company in Bangalore, India — delivering
              scalable, role-based HR solutions with admin dashboards and employee self-service
              portals.
            </p>

            <div className="wdev-intro__highlights">
              {highlights.map((item) => (
                <div className="wdev-intro__highlight" key={item.title}>
                  <div className="wdev-intro__highlight-icon">{item.icon}</div>
                  <div>
                    <h3 className="wdev-intro__highlight-title">{item.title}</h3>
                    <p className="wdev-intro__highlight-desc">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </AnimatedSection>

          <AnimatedSection className="wdev-intro__form-wrap" delay={0.15}>
            <EstimateProjectForm />
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default HrmIntroSection;
